import { CustomButton } from 'components'
import ModalLayout from 'layouts/modal-layout'
import React from 'react'

const ModalDeletePickupServisInspeksi = ({ data, onClose, openModal, onDelete, tipe }) => {
  const fieldStyle = 'text-lg-medium text-gray-900'
  const valueStyle = 'text-md-regular text-gray-700'
  const containerStyle = 'flex flex-col gap-1'
  return (
    <ModalLayout
      className={'max-w-sm'}
      headerTitle={`Hapus Data Unit ${tipe}`}
      onCancel={onClose}
      openModal={openModal}>
      <div className="grid grid-cols-1 gap-4">
        <div className="text-md-medium text-gray-500">
          Apakah Anda yakin ingin menghapus unit {tipe}:
        </div>
        <div className="grid grid-cols-1 gap-4">
          <div className={containerStyle}>
            <span className={fieldStyle}>Unit</span>
            <span className={valueStyle}>
              {`${data?.unitTahun} ${data?.unitMerek} ${data?.unitModel} ${data?.unitTipe}`}
            </span>
          </div>
          <div className={containerStyle}>
            <span className={fieldStyle}>Tanggal</span>
            <span className={valueStyle}>{data?.date}</span>
          </div>
          <div className={containerStyle}>
            <span className={fieldStyle}>Pemilik</span>
            <span className={valueStyle}>{data?.pemilik}</span>
          </div>
          {data?.waktu ? (
            <div className={containerStyle}>
              <span className={fieldStyle}>Waktu Servis</span>
              <span className={valueStyle}>{data?.waktu}</span>
            </div>
          ) : null}
          {data?.waktuPenjemputan ? (
            <div className={containerStyle}>
              <span className={fieldStyle}>Waktu Penjemputan</span>
              <span className={valueStyle}>{data?.waktuPenjemputan}</span>
            </div>
          ) : null}
          {data?.stall ? (
            <div className={containerStyle}>
              <span className={fieldStyle}>Stall</span>
              <span className={valueStyle}>{data?.stall}</span>
            </div>
          ) : null}
          {data?.alamat ? (
            <div className={containerStyle}>
              <span className={fieldStyle}>Alamat</span>
              <span className={valueStyle}>{data?.alamat}</span>
            </div>
          ) : null}
        </div>
        <div className="flex flex-row w-full items-center justify-end space-x-4">
          <CustomButton type="plain" onClick={() => onClose()}>
            Cancel
          </CustomButton>
          <CustomButton onClick={() => onDelete()}>Delete</CustomButton>
        </div>
      </div>
    </ModalLayout>
  )
}

export default ModalDeletePickupServisInspeksi
